/* eslint-disable sort-keys */
export const translation = {
  CertMasterAuthenticateModal: {
    Instructions:
      '> アカウントをクリックして、このCompTIAアカウントにリンクしてください。購入したコースが表示されます。',
    UsernameLabel: 'ユーザー名',
    PasswordLabel: 'パスワード',
    LoginBtn: 'ログインしてアカウントをリンクする',
    ForgotLink: 'ユーザー名またはパスワードを忘れましたか?',
    SupportLink: 'CompTIAサポートにお問い合わせください',
    AlreadyLinked:
      '入力したプラットフォームアカウントは既にCompTIAアカウントにリンクされています。接続方法についてはサポートにお問い合わせください。',
    LoginFailed:
      'ユーザー名またはパスワードが認識されません。アカウントの接続についてはサポートにお問い合わせください。',
  },
  Button: {
    Edit: '編集',
    Cancel: 'キャンセル',
  },

  ComingSoon: {
    ReleaseDate: '近日開始予定',
    RedeemAccessKeys:
      '近日中に、このページからCompTIAトレーニング製品のアクセスキーが登録できるようになります。最新情報をご確認ください。',
    AccessYourTraining:
      '近日中に、このページからCompTIAトレーニング製品にアクセスできるようになります。最新情報をご確認ください。',
    BrowseTraining: 'トレーニングを閲覧する',
  },

  Loading: {
    Default: 'しばらくお待ちください',
    AddressVerification: 'アドレスを認証しています',
    RedeemingAccessKey: 'アクセスキーを確認しています',
    UpdatingProfile: 'プロフィールを更新しています',
    UpdatingEmail: 'Eメールを更新しています',
    UpdatingPassword: 'パスワードを更新しています',
    SendingVerificationCode: '確認コードの送信',
    ResendingVerificationCode: '新しい確認コードの送信',
  },

  Toast: {
    Action: {
      Dismiss: '了解です',
    },
    Error: {
      Default: '予期しないエラーが発生しました。後ほどお試しください。',
    },
    Success: {
      EditProfile: 'プロフィールが更新されました',
      EditEmail:
        'お客様のメールアドレスは正常に変更されました。新しいメールアドレスでサインインするためログインページに移動します。',
      EditPassword: 'パスワードが更新されました',
      VerificationCodeSent:
        '新しいメールアドレスに確認コードが送信されました。次のステップで確認コードを入力しメールアドレスを変更してください。',
    },
  },

  Validation: {
    AlternateEmail: '異なるEメールを使用してください',
    CurrentEmail: '無効なEメールです',
    CurrentPassword: '現在のパスワードとは異なる必要があります',
    InvalidAddress: '無効な住所です',
    InvalidCity: '無効な市町村です',
    InvalidCountry: '無無効な国です',
    InvalidCountryCode: '無効な国コードです',
    InvalidName: '無効な氏名です',
    InvalidPassword:
      '15～64文字で、次のうち３つの要素を含むこと：小文字、大文字、数字（0～9）、一つ以上の記号：@ # $ % ^ & * - _ + = [] {} | \\ : \' , ? / ` ~ " () ; ! .',
    InvalidPhoneNumber: '無効な電話番号です',
    InvalidPostalCode: '無効な郵便番号です',
    InvalidState: '無効な当道府県です',
    MaximumLength: '最大長を超えています',
    PasswordsMatch: 'パスワードが一致しません',
    PrimaryEmail: 'メインのEメールと異なる必要があります',
    PrimaryPhoneNumber: 'メインの電話番号と異なる必要があります',
    Required: '必須',
    ValidEmail: 'Eメールに誤りがあります',
    ValidBirthDay: '無効な誕生日',
    validMobilePhoneNumber:
      'SMS メッセージを受信するには携帯電話番号を入力してください',
  },

  PearsonError: {
    Button: 'ホームページに戻る',
    Default:
      'ピアソンVUEのシステムで、予期しないエラーが発生しました。カスタマサポートまでご連絡ください。',
    CandidateNotFound:
      'ピアソンVUEの受験者情報が見つかりません。カスタマーサポートまでご連絡ください。',
    ClientNotSupported:
      'ピアソンVUEのクライアントがサポートされていません。カスタマーサポートまでご連絡ください。',
    InvalidPayload:
      'ピアソンVUEのペイロードで認証ハッシュ値が一致しません。カスタマーサポートまでご連絡ください。',
    MissingRequiredParameters:
      '必要となるピアソンVUEのペイロードパラメータがクライアントから提供されませんでした。カスタマーサポートまでご連絡ください。',
    RegistrationNotFound:
      'ピアソンVUEの試験登録番号が見つかりません。カスタマーサポートまでご連絡ください。',
    SessionTimeout:
      'ピアソンVUEへのリクエストがタイムアウトしました。カスタマーサポートまでご連絡ください。',
    Temporary:
      'ピアソンVUEのWebサイトで、一時的に計画停止が発生しています。サポートが必要な場合は、コールセンターにお問い合わせください。',
    VueWideBlock:
      'この制限についてのお問い合わせおよび解決につきましては、ピアソンVUEのカスタマーサービスチーム（0120-355-173）に直接お問い合わせください。<br><br>また、その他のピアソンVUEの連絡方法（お問い合わせフォームを含む）は、<a href="https://www.pearsonvue.co.jp/Test-takers/Customer-service.aspx" style="outline: none;" target="_blank">こちら</a>をご覧ください。',
  },

  FullfillmentBanner: {
    'Title-1': '認定証が発送待ちです。送付先住所を確認してください。',
    Button: '住所を確認する',
  },

  AddressVerificationModal: {
    Title: '送付先住所の確認がされると、発送作業が始まります。',
    SuccessMessage: '住所が確認済みで、認定キットが郵送されます。',
    Button: '住所を確認する',
  },

  ProfileMenu: {
    CompTIA: 'CompTIA ID',
    'Nav-1': 'マイプロフィール',
    'Nav-2': 'ログイン情報',
    'Nav-3': 'マイトレーニング',
    Button: 'サインアウト',
    'Link-1': '法的',
  },

  Navigation: {
    'Link-Cert': '試験・資格',
    'Link-Home': 'ホーム',
    'Link-1': '試験予約',
    'Link-2': '試験の管理',
    'Link-3': '資格の管理',
    'Link-4': 'トレーニングにアクセス',
    'Link-5': 'アクセスキーの登録',
    'Link-Return': 'ホームに戻る',
    'Link-GoBack': '戻る',
    'Link-MyExams': '試験の管理',
    'Link-Certifications': '認定資格',
    'Link-ContinuingEducation': '継続教育',
  },

  HomeView: {
    WelcomeHeading: 'CompTIA Centralへようこそ',
    ExamsAndCertification: '試験と認定',
  },

  ExamRegistration: {
    AccommodationsUrl:
      'https://www.pearsonvue.com/jp/ja/test-takers/accommodations.html',
    Title: '試験を予約する',
    Content: 'テストセンターやオンラインで受験できます',
    'List-1': 'テストセンターまたはオンラインを選択',
    'List-2': '日にちと時間を選択',
    'List-3': '試験ポリシーを確認',
    Button: '予約する',
    'Button-2': 'さらに見る',
    Blocked:
      'お客様のアカウントは、CompTIA 認定資格試験への登録が一時的に停止されています。この停止措置に関するお問い合わせは、 <a href="mailto:security@comptia.org">security@comptia.org</a> までご連絡いただき、CompTIA ID 番号をお伝えください。お手数をおかけしますが、どうぞよろしくお願いいたします。',
  },

  PearsonVueDashboard: {
    AccommodationsUrl:
      'https://www.pearsonvue.com/jp/ja/test-takers/accommodations.html',
    Title: '試験の管理',
    Content:
      '試験の予約または変更。オンライン試験の開始やスコアレポートの表示。',
    Button: '試験の予約と管理',
    'Button-2': '試験のポリシー',
    'Button-3': '受験上の配慮について',
  },

  CertificationAccount: {
    Title: '認定資格にアクセス',
    Content:
      '認定ステータスの確認、CE feeの支払い、CEUの提出、認定証PDFのダウンロード',
    Button: '認定資格アカウントを表示',
    ButtonAcct: '認定アカウントを表示',
    ButtonCe: '継続教育',
  },

  AccessYourTraining: {
    Title: 'トレーニング',
    Redeem: 'アクセスキーを利用する',
    Content: 'Study Guide, Labs, eLearningコースにアクセスする',
    Content2:
      'ここにあなたのコースが表示されませんか? 場合によっては、このログイン ポータルの外部からあなたのコースにアクセスできることがあります。<a href="https://help.comptia.org/hc/en-us/articles/11204948577044-Accessing-Training-Products-Through-Your-CompTIA-SSO-Account" rel="noopener noreferrer" target="_blank">詳細はこちら</a>。',
    Content3:
      '最新の CertMaster Learn、Perform、Labs コース、および従来の TestOut「Pro」コースにアクセスするには、<linktag>こちらからサインイン</linktag>してください。',
    Content4:
      'コースが見つかりませんか？このCompTIAアカウントを、ご自身の<linktag>リンクされていない</linktag>アカウントにリンクして、コースを見つけてください。<linktag2>アカウントをリンクするには、こちらをクリックしてください。</linktag2>',
    Button: '開始する',
    'Link-1': 'CertMaster Labs',
    'Link-2': 'CertMaster Practice',
    'Link-3': 'Student & Instructor Guides',
    'Link-4': 'CertMaster Learn',
    'Link-5': 'Self-Paced Study Guides',
    'Link-6': 'CertMaster CE',
    'Link-7': 'CompTIA Labs',
    'Link-8': 'CompTIA Direct - Live Online Training',
    MigrateTitle: 'コース移行のお知らせ',
    MigrateContent1: 'このコースは次の場所に移行されました ',
    MigrateContent2: '引き続きご利用いただけます ',
    MigrateContent3:
      '終了するまで利用できますが、最新バージョンへの切り替えをおすすめします',
    Study: 'Study',
  },

  RedeemInformation: {
    Content:
      'ストア購入の場合、アクセスキーは注文完了後にEメールで送信され、さらにご自身のアカウントの注文履歴から確認することもできます。研修用教材の場合、アクセスキーは通常インストラクターまたは教育機関の担当者から配布されます。',
    Title: 'アクセスキーはどこにありますか?',
  },

  RedeemModule: {
    Label: 'アクセスキーを入力してください',
    Button: '今すぐ登録',
    Content:
      'トレーニングコースのアクセスキーを入力してください。複数のアクセスキーがある場合は、1つずつ入力して引き換えてください。',
    Title: 'アクセスキーの登録',
    NoProducts: 'このアクセス キーは、最大償還限度に達しました。',
    Details: {
      Content: '登録の前に、アクセスキーには所属する組織名と国の情報が必要です',
      Cta: '続ける',
    },
    Demographics: {
      Content:
        'アクセス キーの引き換えプロセスを完了するには、次の情報を入力してください。',
      Cta: '続ける',
    },
    Products: {
      Content:
        'このアクセスキーに関連付けられているコースが複数あります。どのコースを引き換えますか?',
      Label: 'コースを選択',
      Cta: '続ける',
    },
    Success: {
      Content:
        'アクセスキーの引き換えが完了しました。新しいトレーニングコースにアクセスしたり、すべてのコースを閲覧したりできます。',
      Cta: '新しいトレーニングにアクセスする',
      ViewAll: 'すべてのコースを表示',
    },
  },

  CertMasterRedemtionStatus: {
    Success: 'アクセス キーが正常に引き換えられました。',
    InvalidKey: 'アクセス キーが無効です。',
    CanExtendAccess: 'このキーを使用するとアクセスを拡張できます。',
    UserProfileNotFound: 'ユーザープロファイルが見つかりません。',
    HasProductAlready: 'このコースはすでに受講済みです。',
    ReservationNotFound: '予約が見つかりません。',
    ReservationAlreadyUsed: '予約はすでに使用されています。',
    ReservationExpired: '予約は期限切れです。',
    ReservationOverUsed: '予約は過剰使用されています。',
    BadExpiration: '予約の期限が無効です。',
    DuplicateReservationForUser: 'ユーザーの重複予約です。',
    InvalidReservation: '無効な予約です。',
    Ls5ReservationNotSupportedSchools:
      'LS5予約は学校ではサポートされていません。',
    Ls5ReservationNotSupportedTrials:
      'LS5予約はトライアルではサポートされていません。',
    UnknownError: '不明なエラーが発生しました。',
    TempAccessAlreadyUsed: '一時的なアクセスはすでに使用されています。',
    ReservationNotActiveYet: '予約はまだアクティブではありません。',
    SingleProductLinkReservationsMustActivateSubLicenses:
      '単一コースリンクの予約ではサブライセンスを有効にする必要があります。',
  },

  NeedHelp: {
    Title: 'お困りですか？',
    Content: 'FAQを確認してカスタマーサポートに連絡する',
    'List-1': '資格を更新のためのCEUの獲得方法',
    'List-2': '資格試験の予約方法',
    'List-3': '認定証の発送方法',
    Button: 'ヘルプ',
  },

  ExploreLaunchpad: {
    Title: 'CompTIA Launchpadは、試験に関わる全ての情報の単一ソースです',
    Content: 'ご自身のCompTIAトレーニングや認定資格に一度のログインでアクセス ',
    Button: 'Launchpadを見てみる',
  },

  OnboardingSecure: {
    Button: 'さらに見る',
    Title: 'セキュア',
    Content:
      'CompTIA Launchpadでは、ご利用の製品やサービス、試験や資格情報に簡単かつセキュアにアクセスできます。 ',
    'Title-2': 'セキュア',
    'Content-2': '',
  },

  OnboardingConnected: {
    Button: 'さらに見る',
    Title: 'コネクテッド',
    Content:
      'CompTIA Launchpadでは、ご自身の過去、現在、未来の試験情報を確認することができます。全てが一つのアカウントにリンクされています。',
    'Title-2': 'コネクテッド',
    'Content-2': '',
  },

  OnboardingSimple: {
    Button: 'さらに見る',
    Title: '簡単',
    Content:
      '簡単なログイン、業界トップの暗号化で、CompTIA Launchpadでのあらゆる管理を可能にします。',
    'Title-2': '簡単',
    'Content-2': '',
  },

  'FooterColumn-1': {
    Title: 'お問い合わせ',
    'Link-1': 'ヘルプセンター',
    'Link-2': 'アカウント統合のリクエスト',
    'Link-3': '氏名変更のリクエスト',
  },

  'HelpMenu-Links': {
    'Link-1': '/help?returnto=https://help.comptia.org/hc/ja',
    'Link-2':
      '/help?returnto=https://help.comptia.org/hc/ja/articles/115005364083-%E8%A4%87%E6%95%B0%E3%81%AE%E3%82%A2%E3%82%AB%E3%82%A6%E3%83%B3%E3%83%88%E3%81%AE%E7%B5%B1%E5%90%88',
    'Link-3':
      '/help?returnto=https://help.comptia.org/hc/ja/articles/115005363983-%E6%B0%8F%E5%90%8D%E3%81%AE%E5%A4%89%E6%9B%B4%E3%81%BE%E3%81%9F%E3%81%AF%E4%BF%AE%E6%AD%A3',
  },

  'FooterColumn-2': {
    Title: '認定資格',
    'Link-1': 'CompTIA認定資格',
    'Link-2': 'トレーニング製品',
    'Link-3': '継続教育CE',
  },

  'FooterColumn-3': {
    Title: 'Store',
    'Link-1': 'CompTIA Store',
  },

  Profile: {
    Address: {
      Address1: '住所1',
      Address2: '住所2',
      Address3: '住所3',
      AddressType: '住所の種類',
      City: '町',
      Country: '国',
      PostalCode: '郵便番号',
      State: '都道府県',
    },
    AllowCompTIAMarketingContact:
      'CompTIAの製品やサービス、最新情報に関するプロモーション、キャンペーン、新製品の案内を受け取る。CompTIAのセキュアデータベースで管理される個人情報は、私のニーズに応じた製品やサービスを評価するために使用されることに同意します。私はいつでもオプトインの選択を変更する権利を有します。',
    AllowCompTIAPartnerMarketingContact:
      'CompTIAのパートナーから、プロモーション、キャンペーン、新製品の案内、その他有益な情報を受け取る。私はいつでもオプトインの選択を変更する権利を有します。',
    AllowConsentToGatherBirthInformation:
      'CompTIAがあなたの誕生月/年の情報を収集することに同意しますか？',
    AllowConsentToSendSmsTextMessages:
      '私は、CompTIA および関連会社から更新、プロモーション、重要な情報に関する SMS テキスト メッセージを受信することに同意します。',
    AllowConsentToGatherBirthInformation2:
      'CompTIA が私の生まれた日、月、年を収集することに同意します。',
    AllowCredentialReleaseToThirdParty:
      '私は、CompTIAが私の認定資格に付随する情報を第三者機関、政府機関、教育機関に公開することを許可します。私は、CompTIA、その役員、取締役、従業員が、この情報公開に起因する特別/付随/間接/派生的損害またはいかなる損害についても責任を負わないことに同意します。私はいつでもオプトインの選択を変更する権利を有します。',
    AlternateEmail: 'その他のEメール',
    AlternatePhoneNumber: {
      CountryCode: 'コード',
      Phone: 'その他の電話番号',
    },
    BirthMonth: '誕生月',
    BirthYear: '誕生年',
    BirthDay: '誕生日',
    Company: '会社名',
    Email: 'Eメール',
    GivenName: {
      FirstName: '名前',
      Heading: '実名',
      LastName: '名字',
      MiddleName: 'ミドルネーム',
      Suffix: 'サフィックス',
      Title: '敬称',
    },
    IsUsCitizenOlderThanEighteenYears: '米国市民かつ18歳以上ですか？',
    IsOlderThanEighteenYears: 'あなたは18歳以上ですか?',
    MobilePhoneNumber: {
      CountryCode: '国コード',
      Phone: '携帯電話',
    },
    PhoneNumber: {
      CountryCode: '国コード',
      Phone: '電話番号',
    },
    Preferences: {
      Language: '対応言語',
    },
    PreferredName: {
      FirstName: '名前',
      FirstNameQualified: 'ハンドルネーム（名前）',
      Heading: 'ハンドルネーム（氏名）',
      LastName: '名字',
      LastNameQualified: 'ハンドルネーム（名字）',
      MiddleName: 'ミドルネーム',
      Suffix: 'サフィックス',
      Title: '敬称',
    },
    PrivacyPolicyAccepted:
      'CompTIA の<a target="_blank" href="https://www.comptia.org/legal">プライバシー ポリシーと利用規約</a>に同意します',
  },

  EditAccount: {
    Subheading: 'ログイン情報',
    Required: '必須*',
    Email: {
      Tab: 'メールアドレス',
      Heading: 'メインのEメールアドレス',
      EmailAddress: 'Eメールアドレス',
      ConfirmCurrentPassword: 'パスワードの確認',
      Disclaimer:
        '新しいメールアドレスでサインインするためログインページに移動します。',
      VerificationInstructions:
        '新しいメールアドレスに確認コードが送信されます。',
      Social: 'これはSNSアカウントです。Eメールは変更できません',
      SendVerificationCode: '確認コードを送る',
      ResendVerificationCode: '新しい確認コードを送信',
      VerifyCode: '確認コードを確認する',
      VerificationCode: '確認コード',
      NewPassword: '新しいパスワード',
      Submit: '送信',
    },
    Password: {
      Tab: 'パスワード',
      Heading: 'パスワード',
      CurrentPassword: '現在のパスワード',
      NewPassword: '新しいパスワード',
      ConfirmNewPassword: '新しいパスワードの確認',
      Social: 'これはSNSアカウントです。パスワードは変更できません',
    },
    Cta: '保存',
  },

  EditProfile: {
    Subheading: 'ユーザープロフィール情報',
    LegalName:
      '実名の変更や修正については、カスタマサポートまでご連絡ください。',
    ParentGuardianInformation: '同意情報',
    ParentGuardianSubheading: 'あなたのアカウントは{{date}}に同意を得ました。',
    PersonalInformation: '個人情報',
    ContactInformation: '連絡先情報',
    AlternateContactInformation: 'その他の連絡先情報',
    AlternateContactSubheading:
      '将来のアカウント復旧のオプションとして、代替のEメールと電話電話の設定をお勧めします。',
    Cta: '保存',
  },

  PearsonDemographic: {
    Heading: '試験のスケジュールと管理',
    Subheading: 'サインアップ',
    YouMustEnter:
      'リーガルネームは、テストセンターに提示する身分証明書に記載されている通りに正確に入力する必要があります。',
    NameInEnglish: '名字、名前はローマ字で入力してください',
    NoReimbursement:
      '重要：以下の氏名は、受験の際に提示する身分証明書に記載されている氏名と一致する必要があります。一致しない場合、受験することができず、受験料も返金されませんのでご注意ください。',
    Required: '必須*',
    LegalName: '実名',
    PreferredName: 'ハンドルネーム',
    ContactInformation: '連絡先情報',
    Cta: '変更を保存する',
    MissingFields: '必須項目が入力されていません',
  },

  TrainingProducts: {
    Subheading: 'マイトレーニング',
    HeadingTag: '製品',
    ProductType: '製品の種類',
    PersonalAccount: '個人アカウント',
    BusinessAccount: 'ビジネスアカウント',
    ExpiresOn: '有効期限',
    ExpiredOn: '有効期限切れ',
    NoProducts: 'まだトレーニングコースを引き換えていません。',
    WaitingOnAgreement: '保留中の同期と契約の完了 (該当する場合)',
  },

  NotFound: {
    Heading: '404 Not Found',
    Subheading: 'ご希望の情報が見つかりませんか？',
    Button: 'CompTIA アカウントのホーム画面に移動してください。',
  },
  UpgradeAccountModal: {
    Title: 'アクセスキーを引き換えるにはアカウントをアップグレードしてください',
    Intro:
      'アクセス キーを利用するには、最新の CompTIA アカウントにアップグレードする必要があります。',
    NoAccount:
      '<linktag>リンクされていない、レガシーの CertMaster または TestOut LabSim プラットフォーム アカウント</linktag> をお持ちの場合は、この CompTIA アカウントにリンクすることでアカウントをアップグレードできます。',
    HasAccount:
      '<linktag>リンクされていない、または古いCertMaster、またはTestOut LabSim Platformアカウント</linktag>が<strong>{{email} に関連付けられている可能性があります。その場合は、このCompTIAアカウントにリンクすることでアップグレードできます。',
    Otherwise:
      'それ以外の場合は、「リンクされていないアカウントはありません」を選択して自動的にアップグレードします。',
    Upgrading: 'アカウントのアップグレードとは:',
    Item1: '製品が引き換えられ、CompTIA アカウントに追加されます。',
    Item2: '成績、点数、進捗状況、試験は変わりません',
    Item3:
      '接続すると、従来の CertMaster または TestOut LabSim Platform アカウントのログインが現在の CompTIA ログインに置き換えられます。',
    ConnectAccount: 'リンクされていないアカウントに接続する',
    DontHaveAccount: 'リンク解除されたアカウントはありません',
    WhatLink:
      'リンクされていないアカウントまたはレガシー アカウントとは何ですか?',
  },
  UpgradeSuccessModal: {
    Title: 'アカウントのアップグレードが完了しました',
    Upgraded:
      'CompTIAアカウントがアップグレードされ、アクセスキーが引き換えられました。製品がアカウントに表示されるようになりました。',
    Issue:
      '問題が発生した場合は、<linktag>サポートにお問い合わせ</linktag>ください。',
    Continue: 'CompTIAアカウントホームへ進む',
  },
  LinkedSuccessfullyModal: {
    Title: 'アカウントのリンクとアップグレードが正常に完了しました',
    Linked:
      'CompTIA アカウントは、従来の CertMaster または TestOut LabSim プラットフォーム アカウントにリンクされています。',
    Use: '今後は、<linktag>login.comptia.org</linktag> でCompTIAのログイン情報を使用してコースにアクセスしていただきます。以前のCertMasterまたはTestOut LabSim Platformの認証情報はご利用いただけなくなります。',
    Issue:
      '問題が発生した場合は、<linktag>サポートにお問い合わせ</linktag>ください。',
    Continue: 'CompTIAアカウントホームへ進む',
  },
  Links: {
    LegacyAccount:
      'https://help.comptia.org/hc/ja/articles/35180001781396-What-is-an-Unlinked-CertMaster-or-TestOut-LabSim-Platform-account-and-Why-am-I-being-Asked-to-Link-it-to-a-CompTIA-account',
    Support: 'https://help.comptia.org/hc/ja/requests/new',
  },
  NoActivationNeededModal: {
    Title: 'アクティベーション不要',
    Courses: '入力したアクセス キーは次のコース用です:',
    Courses_plural: '入力したアクセス キーは次のコース用です。',
    NotUsed:
      'このコースにはすでにアクセス権があるため、アクセス キーは使用されません。',
    NotUsed_plural:
      'これらのコースにはすでにアクセスできるため、アクセス キーは使用されません。',
  },
  ErrorModal: {
    Title: '引き換えエラー',
    Content: 'アクセス キーの引き換え中にエラーが発生しました: ',
  },
  CertMasterEntry: {
    CoursewareHome: '教材ホーム',
    ClassManagement: 'クラス管理',
    InstitutionManagement: '機関管理',
    EmployeeTools: 'CompTIA管理者ポータル',
  },
  MissingProductsModal: {
    Title: 'アカウントをリンクして不足しているコースを見つける',
    Content1:
      'コースが表示されませんか？LabSim プラットフォームや TestOut LabSim アカウントなど、所有している <linktag>リンクされていないアカウントまたはレガシー アカウント</linktag> にある可能性があります。',
    Content2:
      '不足しているコースを追加するには、リンクされていないアカウントを現在のCompTIAアカウントにリンクしてください。そうでない場合は、「無視」を選択してこのメ​​ッセージを閉じてください。',
    Content3: 'アカウントをリンクするとは:',
    Item1: '購入したコースはこの CompTIA アカウントに表示されます。',
    Item2: '成績、スコア、進捗状況、試験は変わりません。',
    Item3:
      'これにより、リンク解除されたアカウント ログインが現在の CompTIA ログインに置き換えられます (引き続き使用します)。',
    Content4:
      'リンクされていないアカウントまたはレガシー アカウントとは何ですか?',
    Button1: '無視する',
    Button2: 'アカウントをリンクする',
  },
  InfoText: {
    Unlinked:
      'コースが見つかりませんか？このCompTIAアカウントを、ご自身の<linktag>リンクされていない</linktag>アカウントにリンクして、コースを見つけてください。<linktag2>アカウントをリンクするには、こちらをクリックしてください。</linktag2>',
    AccessKeys:
      'ストアでご購入の場合、アクセスキーはご注文完了後にメールで送信されます。また、ストアアカウントの注文履歴からも取得できます。講師主導のトレーニングの場合、アクセスキーは通常、講師または教育機関の管理者から配布されます。',
    NoCourses:
      '現在、コースはありません。<linktag>アクセスキーを引き換える</linktag>をクリックして開始してください。',
  },

  ConsentManagement: {
    Title: '年齢確認',
    AgeDescription: '正確で真実の年齢を選択してください。',
    AgeNote:
      '** 注意：不正確な情報はサービスに影響を与え、アクセスの中断を引き起こす可能性があります。',
    AgeLabel: '年齢',
    SubmitAge: '続行',
    GuardianTitle: '保護者、後見人、または講師の同意が必要です',
    GuardianDescription:
      '学生のプライバシーは私たちにとって重要です。私たちは、子供のプライバシーの分野をリードする信頼できるサードパーティプロバイダー<privolink>PRIVO</privolink>と協力し、学生がCompTIA Centralに参加するための保護者の同意を取得しています。続行するには、保護者または後見人のメールアドレスを入力してください。',
    GuardianInstructorNote:
      '保護者の同意に代わって生徒の同意を提供したいインストラクターの方は、手続きを続行する前に直接お問い合わせいただく必要があります。生徒への同意の付与方法の詳細については、<instructorlink>こちらのリンク</instructorlink>をご確認ください。',
    GuardianDeclineNote:
      '注意：同意を拒否しても、必要なプロセスを回避することはできません。',
    GuardianEmailLabel: '保護者、後見人、または講師のメールアドレス',
    SelectInstructor:
      '貴機関に所属するインストラクターを選択するか、一覧にない場合は、同意者として承認されていることが分かっているインストラクターのメールアドレスを入力してください。',
    SubmitGuardian: '続行',
    PendingTitle: '同意承認待ち',
    PendingDescription:
      '保護者/後見人/講師の同意承認を待っています。以下でメールアドレスを更新するか、リクエストを再送信できます。既に承認済みの場合は、下の「更新」をクリックしてステータスを確認してください。',
    SentConfirmation:
      '保護者/後見人/講師に同意リクエストのメールを送信しました。承認されると、CompTIAのアプリケーションに完全にアクセスできるようになります。既に承認済みの場合は、下の「更新」をクリックしてステータスを確認してください。',
    ResendButton: '同意リクエストを再送信',
    RefreshStatus: '更新',
    ResendLimitReached:
      '同意リクエストの再送信の1日の上限に達しました。24時間後に再度お試しください。',
    SameEmailError:
      'このメールアドレスはご自身のメールアドレスと同じにすることはできません。',
    InvalidEmailError: '有効なメールアドレスを入力してください。',
    SignOut: 'サインアウト',
  },

  AccountDeletion: {
    Title: 'アカウント削除処理中',
    Message:
      'お客様のアカウントは、保護者、後見人、または講師のリクエストにより、現在削除処理中です。ご質問がある場合は、',
    ContactUs: 'お問い合わせ',
    SignOut: 'サインアウト',
  },
};
